import debounce from "@mui/utils/debounce";
import { Box, Slider, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";

export interface VectorSearchDistanceSliderProps {
    defaultVectorSearchDistance: number;
    onVectorSearchDistanceChanged: (newDistance: number) => void;
}

export function VectorSearchDistanceSlider(
    props: VectorSearchDistanceSliderProps,
) {
    const [value, setValue] = useState(props.defaultVectorSearchDistance);

    const debouncedOnChange = useMemo(
        () => debounce(props.onVectorSearchDistanceChanged, 500),
        [props.onVectorSearchDistanceChanged],
    );

    return (
        <Box sx={{ width: "80%", mx: "auto" }}>
            <Typography gutterBottom>Distance</Typography>
            <Stack
                direction="row"
                spacing={2}
                alignItems="center"
            >
                <Slider
                    size="small"
                    value={value}
                    step={0.05}
                    max={0.8}
                    min={0.1}
                    marks
                    valueLabelDisplay="auto"
                    onChange={(event, sliderValue) => {
                        const nextValue = Array.isArray(sliderValue)
                            ? sliderValue[0]
                            : sliderValue;

                        setValue(nextValue);
                        debouncedOnChange(nextValue);
                    }}
                    sx={{ flexGrow: 1 }}
                />
                <Typography variant="body2">{value.toFixed(2)}</Typography>
            </Stack>
        </Box>
    );
}
